import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/layout/Header';
import PrimaryBox from '../../components/layout/PrimaryBox';
import FormsTable from '../../components/tables/qhse/forms/FormsTable';
import { usePageTitle } from '../../hooks/usePageTitle';
import { capitalizeFirstLetter } from '../../utils/capitalize';

const FormsPage: React.FC = () => {
    const { t } = useTranslation();

    usePageTitle(capitalizeFirstLetter(t('forms')));

    return (
        <PrimaryBox>
            <Header
                title={t('qhse')}
                breadcrumbs={[{ label: capitalizeFirstLetter(t('forms')) }]}
                subTitle={capitalizeFirstLetter(t('forms'))}
                isDateVisible={false}
            ></Header>
            <FormsTable />
        </PrimaryBox>
    );
};

export default FormsPage;
